import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Button, DialogActions, DialogContent, Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { groupNamesSummary } from '../../helpers';
import { ContactCaptureOffer } from '../../types';
import { BhiDialog } from 'src/UIKit';
import { StepCallout } from './StepCallout.styles';

interface ContactCaptureOfferDialogProps {
  offer: ContactCaptureOffer | null;
  open: boolean;
  onAccept: () => void;
  onClose: () => void;
}

export const ContactCaptureOfferDialog: FC<ContactCaptureOfferDialogProps> = ({
  offer, open, onAccept, onClose,
}) => {
  const groups = groupNamesSummary(offer?.groupNames ?? []);
  const bold = (text: string) => (
    <Typography component="span" variant="body2" fontWeight="fontWeightSemiBold">{text}</Typography>
  );

  return (
    <BhiDialog
      open={open && Boolean(offer)}
      onClose={onClose}
      title="Campaign is active"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent sx={{ pt: 0 }}>
        <Typography variant="body2" color="text.secondary">
          <Typography component="span" variant="body2" fontWeight="fontWeightSemiBold" color="text.primary">
            {offer?.campaignName}
          </Typography>
          {' '}is now active. One more step to grow your list.
        </Typography>
        <Stack spacing={1} mt={2}>
          <StepCallout status="done">
            <CheckCircleOutlineIcon />
            <div>
              <Typography variant="body2" fontWeight="fontWeightSemiBold" color="success.dark">
                Join campaign activated
              </Typography>
              <Typography variant="body2">
                Contacts can now join this campaign
                {groups.shown.length > 0 && (
                  <>
                    {' '}and are added to {bold(groups.shown[0])}
                    {groups.shown[1] && <>{groups.rest ? ', ' : ' and '}{bold(groups.shown[1])}</>}
                    {groups.rest > 0 && <> and {groups.rest} more</>}
                  </>
                )}
              </Typography>
            </div>
          </StepCallout>
          <StepCallout status="next">
            <RadioButtonUncheckedIcon />
            <div>
              <Typography variant="body2" fontWeight="fontWeightSemiBold" color="text.primary">
                Add a signup form to your website
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Visitors who submit it join this campaign automatically
              </Typography>
            </div>
          </StepCallout>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>Not now</Button>
        <Button variant="contained" onClick={onAccept}>Create contact capture</Button>
      </DialogActions>
    </BhiDialog>
  );
};
